module.exports = __webpack_public_path__ + "static/media/web_secure.b30a6379.gif";